import styled from '@emotion/styled'
import { Typography } from '@material-ui/core'
import dayjs from 'dayjs'
import React, { useCallback, useMemo, useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import {
  getColorDcaPlanText,
  getColorPaymentStatus,
  getColorStatusBankAccountBadge,
  getColorStatusBankAccountText,
  useRouter,
} from '../../../../utils/helper'

import { Authorize } from '../../../components/Authorize'
import Text from '../../../components/common/Text'
import DetailPage from '../../../components/templates/DetailPage'

import { appConfig } from '../../../constants/app-config'
import { useGetDca, useGetTransactionDcaByDcaRef } from '../../../services/dca/dca-query'
import { EnumFrequencyDcaType } from '../../../services/dca/dca-typed'
import { Transaction } from '../../../services/transaction/transaction-typed'
import { ROLE } from '../../../services/user/user-typed'
import PortCard from '../../port/PortDetail/PortCard'
import SafeGoldCallBacksCard from '../../transaction/TransactionDetail/SafeGoldCallBacksCard'
import TransactionCard from '../../transaction/TransactionDetail/TransactionCard'
import UserCard from '../../user/UserProfile/UserCard'
import DcaCard from './DcaCard'

const Layout = styled.div`
  display: flex;
  flex: 1;
  flex-flow: row;
  align-items: center;
  justify-content: flex-end;
  grid-gap: 8px;
  height: 100%;
  padding-right: 16px;
`

const TextLib = styled(Typography)`
  line-height: 2 !important;
`

const Grid = styled.div`
  display: grid;
  grid-gap: 10px;
  margin-top: 10px;
`

const Flex = styled(Grid)`
  display: flex;
  grid-gap: 10px;
  margin-top: 0px;
`
const TextColor = styled(TextLib)<{ color?: string }>`
  color: ${({ color }) => color};
  font-weight: bold !important;
`

const DcaDetail = () => {
  const { dcaId } = useRouter().query
  const [page, setPage] = useState(1)
  const { data: dca } = useGetDca(dcaId)

  const { data: transactionDcas } = useGetTransactionDcaByDcaRef(dca?.externalReference || '', {
    page: page || 1,
  })

  const handlePageChange = useCallback((page:number) => {
    setPage(page)
  },[])

  const dcaPlanData = useMemo(
    () => [
      {
        label: 'Price',
        value: <Text>{`${Number(dca?.value || 0)} Baht`}</Text>,
      },
      {
        label: 'Date',
        value: (
          <Text>
            {dca?.type === EnumFrequencyDcaType.WEEKLY
              ? `${dayjs()
                  .day(Number(dca.date))
                  .format('dddd')}`
              : `Every ${dca?.date} of the month`}
          </Text>
        ),
      },
      {
        label: 'Type ',
        value: <Text>{dca?.type}</Text>,
      },
      {
        label: 'Status',
        value: <Text color={getColorDcaPlanText(dca?.status)}>{`${dca?.status}`}</Text>,
      },
    ],
    [dca],
  )

  return (
    <div>
      <DetailPage
        title={
          <Flex>
            <TextColor variant="h5">Dca plan</TextColor>
            {/* <TextColor variant="h5">{balance ? `${balance} Baht Gold` : '-'}</TextColor> */}
            <Layout>
              {/* <Button
                onClick={onClickRefreshBalance}
                variant={'secondary'}
                disabled={fetchBalanceLoading}
              >
                {fetchBalanceLoading && (
                  <Spinner
                    animation="border"
                    style={{
                      marginBottom: '-4px',
                      marginRight: '8px',
                    }}
                  />
                )}
                Refresh Balance
              </Button> */}
            </Layout>
          </Flex>
        }
        contents={dcaPlanData}
        gridItems={[
          <UserCard userId={dca?.port?.userId || ''} />,
          <PortCard portId={dca?.port?.id || ''} />,
        ]}
      />

      <DcaCard transaction={transactionDcas} onPageChange={handlePageChange} />
    </div>
  )
}

export default DcaDetail
